import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../../apiConfig";
import { useNavigate } from "react-router-dom";

export default function AdminRegister() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const register = async () => {
    setError("");

    if (!username.trim() || !password.trim() || !confirmPassword.trim()) {
      setError("All fields are required");
      return;
    }

    if (password.length < 5) {
      setError("Password must be at least 5 characters");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const res = await axios.post(`${API_BASE}/adminRegister.php`, {
        username,
        password,
      });

      if (res.data.status === "success") {
        alert(res.data.message);
        navigate("/admin-login");
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError("Registration failed. Try again!");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-11 col-md-5">
          <div className="card shadow border-0 rounded-4 p-4">
            <h3 className="fw-bold mb-3 text-center">Admin Register 🧾</h3>

            {error && <div className="alert alert-danger">{error}</div>}

            <input
              className="form-control form-control-lg mb-3"
              placeholder="New Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              className="form-control form-control-lg mb-3"
              placeholder="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Confirm Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <button className="btn btn-success btn-lg w-100" onClick={register}>
              Register
            </button>

            <div className="text-center mt-3">
              <small className="text-muted">
                Already have account?{" "}
                <a href="/admin-login" className="text-decoration-none">
                  Login
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
